var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"icon":"","type":_vm.type,"size":"sm"},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('span',{staticClass:"btn-inner--icon"},[_c('i',{class:`${_vm.icon}`})]):_vm._e(),_c('span',{staticClass:"btn-inner--text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }